export default "__VITE_ASSET__DacxAq6N__"